// package
import { Fragment, useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Row,
  OverlayTrigger,
  Tooltip,
  Form,
  Spinner
} from "react-bootstrap";
import Select from "react-select";
import AmlHashForm from "aml-hash-form";

// component
import PageBreadcrumb from "elements/System/PageBreadcrumb";
import AgDelete from "elements/System/AgDelete";
import AgStatus from "elements/System/AgStatus";
import { api, common } from "includes";

export default function AddAdvertisement() {
  // const
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let mode = searchParams.get("mode");
  let id = searchParams.get("id");

  // state
  const [process, setProcess] = useState<any>({ result: 100 });
  const [confirm, setConfirm] = useState<any>({ id: null, type: null });
  const [submit, setSubmit] = useState<any>("");
  const [resultList, setResultList] = useState<any>(null);
  const [permission] = useState(common.getUserPermission());
  // form
  const formFields = {
    title: { validate: ["req#title is required"] },
    subTitle: { validate: ["req#subtitle is required"] },
    adType: { validate: ["req#type is required"], obj: "value" },
    page: { validate: ["req#page is required"], obj: "value" },
    position: { validate: [""] },
    image: { validate: [""] },
    link: { validate: [""] },
    actionTitle: { validate: [""] },
    active: { validate: [""], obj: "value" },

  };

  const {
    fields,
    errors,
    handleChange,
    handleSubmit,
    setValue,
    setMultiValue,
  } = AmlHashForm(formFields);

  // effect
  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200)
    }
  }, []);

  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200)
    }
  }, [mode]);

  // api 
  const getData = () => {
    processState("result", 100)
    let data: any = {
      url: `admin/advertisement/${id}`,
      method: "GET",
    };
    api.call(
      data,
      (res: any) => {
        processState("result", res.status)
        if (res.status === 200) {
          let result = res.data;
          setResultList(result);
          setMultiValue({
            title: result.result.title || "",
            subTitle: result.result.subTitle || "",
            adType: { label: result.result.adType, value: result.result.adType },
            page: { label: result.result.page, value: result.result.page },
            position: result.result.position || "",
            image: result.result.image || "",
            link: result.result.link || "",
            actionTitle: result.result.actionTitle || "",
            active: { label: (Boolean(result.result.active) === true ? "Yes" : "No"), value: (Boolean(result.result.active) === true ? "Yes" : "No") },
            views: result.result.views !== undefined ? result.result.views : null, // Only set if available
            clicks: result.result.clicks !== undefined ? result.result.clicks : null, // Only set if available
            dateandtime: result.result.dateandtime || ""
          });
        }
      }
    );
  };

  const save = () => {
    let data = common.formPayload(fields, []);
    data.adType = fields.adType?.value;
    data.page = fields.page?.value;
    data.active = fields.active?.value === "Yes";


    let param = {
      url: id ? `admin/advertisement/${id}` : `admin/advertisement/`,
      method: id ? "PUT" : "POST",
      body: data,
    };

    api.call(
      param,
      (res: any) => {
        if (res.status === 200) {
          common.notify("S", "Advertisement updated successfully");
          if (id) {
            navigate(`/advertisement/form?id=${id}&mode=view`);
            processState("result", 100)
            getData();
          } else {
            navigate(`/advertisement/list`);
          }
        } else {
          common.notify("E", res?.data.error);
        }
        setSubmit("");
      }
    );
  };

  const deleteLocality = () => {
    let data: any = {
      url: `admin/advertisement/${confirm.id}`,
      method: "DELETE",
    };

    api.call(data, (res: any) => {
      if (res.status === 200) {
        setConfirm({ id: null, type: "" });
        common.notify("S", "Advertisement deleted successfully");
        navigate(`/advertisement/list`);
      } else {
        common.notify("E", res.error);
      }
    });
  };

  // events
  const onSubmit = (e: any) => {
    e.preventDefault();
    const isValid = handleSubmit();
    if (isValid) {
      setSubmit("submit");
      save();
    }
  };

  const deleteCallBack = (isDelete: boolean) => {
    if (isDelete) {
      deleteLocality();
    } else {
      setConfirm({ id: null, type: "" });
    }
  };

  // callback
  const onAgCallBack = (status: any) => {
    getData();
  };

  // support
  const processState = (label: any, value: any) => {
    setProcess((prev: any) => ({
      ...prev,
      [label]: value
    }));
  }

  return (
    <Fragment>
      <PageBreadcrumb
        breadCrumbItems={[
          { label: "Advertisement", path: "/advertisement/list" },
          { label: "Advertisement Form", path: "/advertisement/list", active: true },
        ]}
        title={"Advertisement Form"}
      />
      {process.result != 200 ? (
        <AgStatus
          process={process.result}
          message={{
            100: "Loading... Please wait!",
            404: "Something went wrong! Please Refresh Again",
          }}
          button={{ 400: "Refresh", 404: "Refresh" }}
          size="l"
          onAgCallBack={onAgCallBack}
        />
      ) : (<Fragment>
        {mode != "view" ? (
          <Fragment>
            {" "}
            <Row>
              <Col xl={12} lg={12}>
                <Card>
                  <Card.Body className="py-1 px-1 border-bottom border-light">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="float-start">
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id="">Back</Tooltip>}
                        >
                          <Link
                            to="/advertisement/list"
                            className="text-reset fs-20 p-1 d-inline-block"
                          >
                            <i
                              className="ri-arrow-left-s-line pe-2"
                              data-bs-container="#tooltips-container"
                              data-bs-toggle="tooltip"
                            />
                          </Link>
                        </OverlayTrigger>
                        <label className="form-check-label fs-16">
                          {id ? "Edit" : "Add"} Advertisement
                        </label>
                      </div>
                      <div id="tooltips-container d-flex align-items-center">
                        <div className="d-flex flex-wrap gap-2">
                          <Button variant="secondary" onClick={() => { navigate("/advertisement/list") }} disabled={submit === "submit"}>
                            <i className=" ri-arrow-go-back-line me-1" />
                            Cancel
                          </Button>
                          <Button variant="primary" onClick={onSubmit} disabled={submit === "submit"}>
                            {submit === "submit" ? (
                              <>
                                <Spinner className="spinner-border-sm me-1" color="white" />
                                Processing...
                              </>
                            ) : (
                              <><i className="ri-save-line" /> Save</>
                            )}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <Card.Body>
                    <Form>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label >Title</Form.Label>
                            <Form.Control
                              type="text"
                              name="title"
                              id="singleLine"
                              maxLength={100}
                              data-toggle="maxlength"
                              placeholder="Enter advertisement title"
                              value={fields.title}
                              onChange={handleChange}
                              isInvalid={errors.title ? true : false}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.title}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Subtitle</Form.Label>
                            <Form.Control
                              type="text"
                              name="subTitle"
                              id="singleLine"
                              maxLength={100}
                              data-toggle="maxlength"
                              placeholder="Enter Subtitle"
                              value={fields.subTitle}
                              onChange={handleChange}
                              isInvalid={errors.subTitle ? true : false}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.subTitle}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Type</Form.Label>
                            <Select
                              options={options}
                              value={fields.adType}
                              onChange={(e) => setValue("adType", e)}
                              classNamePrefix="react-select"
                              className={
                                errors.adType ? "select2 z-5 required-select-input" : "select2 z-5"
                              } />
                            {errors.adType && <span className="text-danger fs-6">
                              {errors.adType}
                            </span>
                            }
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Page</Form.Label>
                            <Select
                              options={pageOptions}
                              value={fields.page}
                              onChange={(e) => setValue("page", e)}
                              classNamePrefix="react-select"
                              className={
                                errors.page ? "select2 z-5 required-select-input" : "select2 z-5"
                              } />
                            {errors.page && <span className="text-danger fs-6">
                              {errors.page}
                            </span>
                            }
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Position</Form.Label>
                            <Form.Control
                              type="text"
                              name="position"
                              id="singleLine"
                              maxLength={100}
                              data-toggle="maxlength"
                              placeholder="Enter position number"
                              value={fields.position}
                              onChange={handleChange}
                              isInvalid={errors.position ? true : false}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.position}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                              type="text"
                              name="image"
                              id="singleLine"
                              maxLength={100}
                              data-toggle="maxlength"
                              placeholder="Enter link"
                              value={fields.image}
                              onChange={handleChange}
                              isInvalid={errors.image ? true : false}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.image}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Image Url</Form.Label>
                            <Form.Control
                              type="text"
                              name="link"
                              id="singleLine"
                              maxLength={100}
                              data-toggle="maxlength"
                              placeholder="Enter image url"
                              value={fields.link}
                              onChange={handleChange}
                              isInvalid={errors.link ? true : false}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.link}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Action Title</Form.Label>
                            <Form.Control
                              type="text"
                              name="actionTitle"
                              id="singleLine"
                              maxLength={100}
                              data-toggle="maxlength"
                              placeholder="Enter Action Title"
                              value={fields.actionTitle}
                              onChange={handleChange}
                              isInvalid={errors.actionTitle ? true : false}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.actionTitle}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Active</Form.Label>
                            <Select
                              options={actionOptions}
                              value={fields.active}
                              onChange={(e) => setValue("active", e)}
                              classNamePrefix="react-select"
                              className={
                                errors.active ? "select2 z-5 required-select-input" : "select2 z-5"
                              } />
                            {errors.active && <span className="text-danger fs-6">
                              {errors.active}
                            </span>}
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Fragment>
        ) : (
          <Fragment>
            <Row>
              <Col xl={12} lg={12}>
                <Card>
                  <Card.Body className="py-1 px-1 border-bottom border-light">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="float-start">
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id="">Back</Tooltip>}
                        >
                          <Link
                            to="/advertisement/list"
                            className="text-reset fs-20 p-1 d-inline-block"
                          >
                            <i
                              className="ri-arrow-left-s-line pe-2"
                              data-bs-container="#tooltips-container"
                              data-bs-toggle="tooltip"
                            />
                          </Link>
                        </OverlayTrigger>
                        <label className="form-check-label fs-16">
                          Advertisements Information
                        </label>
                      </div>
                      {permission.includes("adu") && <div id="tooltips-container d-flex align-items-center">
                        <div className="d-flex flex-wrap gap-2">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id="">Edit</Tooltip>}
                          >
                            <Button
                              className="btn btn-light"
                              onClick={() => {
                                navigate(`/advertisement/form?id=${id}&mode=edit`);
                              }}
                            >
                              <i
                                className="ri-edit-2-line"
                                data-bs-container="#tooltips-container"
                                data-bs-toggle="tooltip"
                              />
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </div>}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <Card.Body>
                    <Form>
                      <Row>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Title</Form.Label>
                            <p className="text-muted fs-14">{resultList.result.title || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Subtitle</Form.Label>
                            <p className="text-muted fs-14">{resultList.result.subTitle || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Type</Form.Label>
                            <p className="text-muted fs-14">{resultList.result.adType || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Page</Form.Label>
                            <p className="text-muted fs-14">{resultList.result.page || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Link</Form.Label>
                            <p className="text-muted fs-14">
                              <Link
                                to={resultList.result.image ? resultList.result.image : "#"}
                                target="_blank"
                              >
                                {resultList.result.image ? resultList.result.image : "-"}
                              </Link>
                            </p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Image Url</Form.Label>
                            <p className="text-muted fs-14">
                              <Link
                                to={resultList.result.link ? resultList.result.link : "#"}
                                target="_blank"
                              >
                                {resultList.result.link ? resultList.result.link : "-"}
                              </Link>
                            </p>

                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Action Title</Form.Label>
                            <p className="text-muted fs-14">{resultList.result.actionTitle || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Active</Form.Label>
                            <p className="text-muted fs-14">{Boolean(resultList.result.active === true) ? "Yes" : "No"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Date and time created</Form.Label>
                            <p className="text-muted fs-14">{resultList.result.dateandtime || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Number of Views</Form.Label>
                            <p className="text-muted fs-14">{resultList.result.views || 0}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Number of Clicks</Form.Label>
                            <p className="text-muted fs-14">{resultList.result.clicks || 0}</p>
                          </Form.Group>
                        </Col>
                        {permission.includes("add") && <Col md={4}>
                          <Button
                            variant="danger"
                            size="sm"
                            className="me-1 d-felx align-items-center"
                            onClick={() => setConfirm({ id: id })}
                          >
                            <i className="ri-delete-bin-line fs-16" />
                            <span className="ms-1">Permanently Delete Advertisement</span>
                          </Button>
                        </Col>}
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Fragment>
        )}
      </Fragment>
      )}
      {/* Delete confirmation */}
      {confirm.id && (
        <AgDelete
          type="delete"
          onAgDeleteCallBack={deleteCallBack}
        />
      )}
    </Fragment>
  );
}

export const options = [
  { value: "Full Page", label: "Full Page" },
  { value: "Inline", label: "Inline" },
];
export const pageOptions = [
  { value: "Incidents", label: "Incidents" },
  { value: "News", label: "News" },
];
export const actionOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];
